import { store } from '../../store'
import { httpgst } from '../../main'

const state = {}
const getters = {}

const DETAIL_URL = 'api/travel-expenses-request/by-folio/'

// El endpoint conserva el nombre `to-xls`, pero el archivo se entrega como libro moderno (.xlsx),
// igual que el resto de descargas de Excel del proyecto.
const DOWNLOAD_EXTENSION = {
  pdf: 'pdf',
  xls: 'xlsx'
}

const actions = {
  getAdvances ({ commit, dispatch }, payload) {
    let url = 'api/reports/requests-vs-expenses'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    let params = {
      startDate: payload.event.data.startDate,
      endDate: payload.event.data.endDate,
      requestStatus: payload.event.data.requestStatus ? payload.event.data.requestStatus : null,
      userId: payload.event.data.userId ? payload.event.data.userId : null,
      projectId: payload.event.data.projectId ? payload.event.data.projectId : null,
      type: payload.event.data.type
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { responseType: payload.event.data.typeRequest === 1 ? null : 'blob', params }, options)
      .then(response => {
        commit('onGetAdvances', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      })
  },
  /** Detalle completo de una solicitud (modal "ver detalle"). */
  getRequestDetail ({ commit }, payload) {
    let url = DETAIL_URL + encodeURIComponent(payload.event.data.folio)
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url)
      .then(response => {
        commit('onGetRequestDetail', { event: payload.event, response: response })
      },
      error => {
        commit('onErrorRequestDetail', { event: payload.event, error: error })
      })
  },
  /**
   * Descarga de la solicitud en PDF / Excel (mismo endpoint que el formulario de
   * reservas). Los renglones del reporte no traen id, así que si no viene se
   * resuelve primero con el detalle por folio.
   */
  downloadRequest ({ commit }, payload) {
    let data = payload.event.data
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

    let resolveId = data.id
      ? Promise.resolve(data.id)
      : httpgst.get(DETAIL_URL + encodeURIComponent(data.folio))
        .then(response => response.data && response.data.data ? response.data.data.id : null)

    resolveId
      .then(id => {
        if (!id) return Promise.reject(new Error('REQUEST_NOT_FOUND'))
        return httpgst.get(`api/travel-expenses-request/to-${data.type}/${id}`, { responseType: 'blob' })
      })
      .then(response => {
        commit('onDownloadRequest', { event: payload.event, response: response })
      },
      error => {
        commit('onErrorDownloadRequest', { event: payload.event, error: error })
      })
  }
}

const mutations = {
  onGetAdvances (state, payload) {
    if (payload.event.context.typeRequest === 1) {
      payload.event.context.items = payload.response.data.data.reportData
      payload.event.context.loading = false
      payload.event.context.loadingItems = false
      payload.event.context.close()
    } else {
      let date = payload.event.context.getReportDate()
      payload.event.context.forceFileDownload(payload.response.data, `Advances request report ${date}.xlsx`)
      payload.event.context.downloadLoading = false
    }
  },
  onGetRequestDetail (state, payload) {
    let context = payload.event.context
    let detail = payload.response.data && payload.response.data.data

    // Si no vino la solicitud se conserva lo que ya se pintó de la tabla.
    if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
      context.selectedRequest = detail
    }
    context.loadingRequestDetail = false
  },
  onDownloadRequest (state, payload) {
    let context = payload.event.context
    let data = payload.event.data
    let extension = DOWNLOAD_EXTENSION[data.type] || data.type
    context.forceFileDownload(payload.response.data, `Request-${data.folio}.${extension}`)
    context.downloadingRequest = ''
  },
  onErrorDownloadRequest (state, payload) {
    let context = payload.event.context
    let response = payload.error && payload.error.response
    context.downloadingRequest = ''

    if (response && response.status === 401) {
      context.showNotification(context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { context.$router.push({ name: 'LoginPage' }) }, 2000)
      return
    }

    // Con responseType blob el mensaje de error del back también llega como blob.
    if (response && response.data instanceof Blob) {
      let reader = new FileReader()
      reader.onload = () => {
        try {
          context.showNotification(JSON.parse(reader.result).message || context.$t('validation.error'), 'error', -1)
        } catch (e) {
          context.showNotification(reader.result || context.$t('validation.error'), 'error', -1)
        }
      }
      reader.readAsText(response.data)
      return
    }

    context.showNotification(response || context.$t('validation.error'), 'error', -1)
  },
  onErrorRequestDetail (state, payload) {
    let context = payload.event.context
    let response = payload.error && payload.error.response

    if (response && response.status === 401) {
      context.showNotification(context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      context.showNotification(response || payload.error, 'error', -1)
    }
    context.loadingRequestDetail = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.downloadLoading = false
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/advancesRequest.js